export const facilityTenantSearchHeaders = [
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Unit #",
    value: "unit_numbers"
  },
  {
    text: "Active Rental",
    value: "is_active"
  },
  {
    text: "Access Code",
    value: "access_code"
  },
  {
    text: "Email",
    value: "email"
  },
  {
    text: "Phone",
    value: "phone_number"
  },
  {
    text: "Actions...",
    sortable: false,
    value: "actions",
    width: "250px"
  }
];
